export default __webpack_public_path__ + "assets/17cff8c82d2da63f66b6ee65b35c3f1f.png";